
<style lang="less">
.day-stat-rows {
  .day-stat-group {
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 20px;
    margin: 0 4px 24px;
    padding: 10px 0 16px;

    .day-stat-rows-category {
      text-transform: uppercase;
      font-size: 15px;
      margin-bottom: 8px;
      text-align: center;
    }

    > .day-stat-row {
      margin-bottom: 24px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>

<template>
  <div class="day-stat-rows">
    <div v-for="group of groups" class="day-stat-group">
      <div class="day-stat-rows-category" v-if="group.category">{{ group.category }}</div>
      <day-stat-row v-for="row of group.rows" :cells="row" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import _ from 'lodash';
import { IStatCell } from './day-stat-row.vue';
import DayStatRow from './day-stat-row.vue';

interface IStatGroup {
  category: string;
  cells: IStatCell[];
  rows: IStatCell[][];
}

const props = defineProps<{ cells: (IStatCell | string)[] }>();

const groups = _.reduce(props.cells, (result, item) => {
  if (typeof item === 'string') {
    result.push({ category: item, cells:[], rows: [] }); // start new group
  } else {
    if (!result.length) result.push({ category: '', rows:[], cells:[] });
    result[result.length - 1].cells.push(item);
  }
  return result;
}, [] as IStatGroup[]);

for (const group of groups) {
  group.rows = _.chunk(group.cells, 4);
}

</script>
